// extracted by mini-css-extract-plugin
export default {"container":"Option_container__4pfEK","heading":"Option_heading__xYIXD","inp":"Option_inp__4RxmD","close":"Option_close__gUbwC"};